import { FaAndroid, FaApple } from 'react-icons/fa';
import { IoOpenOutline } from 'react-icons/io5';

import './AppComponent.scss';

export const AppComponent = (props) => {
	const client = props.client;

	return (
		<div className="app-data">
			<div>
				<img
					className="icon"
					src={client.icon}
				/>
			</div>
			<div className="infos">
				<div className="name-container">
					<span className="name">
						<strong>{client.name}</strong>
					</span>
				</div>
				<span className="package">{client.package}</span>

				<a
					target="_blank"
					href={client.url}
					title="Ir para a Google Play">
					<span className="version">
						<FaAndroid /> {client.version}
					</span>{' '}
					<IoOpenOutline className="open-icon" />
				</a>

				<a
					target="_blank"
					href={`https://apps.apple.com/br/app/id${client.appleId}`}
					title="Ir para a Apple store">
					<span className="version">
						<FaApple /> {client.iosVersion}
					</span>{' '}
					<IoOpenOutline className="open-icon" />
				</a>

				<span>Atualizado em {client.updateDate}</span>
			</div>
		</div>
	);
};
